module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

(function(fox) {
	fox.registerWidget('SitePage_Affiliate', {
		configure: function () {
			this.registerOptions('', {
				container: '#container',
				template: 'affiliateAgreement'
			});
		
			this.callParent('configure', arguments);
		},
	}, 'Site_Page');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/terms.js
// module id = 931
// module chunks = 4